import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@mui/styles';

const GlobalIndicator = ({
  inline = false,
  isGlobal = false,
  showText = true,
  text = 'Global',
  ...props
}: any) => {
  const classes = classnames(props.classes.root, {
    [props.classes.absolute]: !inline,
    [props.classes.noMarker]: !isGlobal,
  });

  return <span className={classes}>{showText && text}</span>;
};

const styles = ({ palette }: any) => {
  return {
    root: {
      display: 'flex',
      alignItems: 'baseline',
      position: 'relative',

      '&:before': {
        content: '""',
        width: 12,
        height: 12,
        marginRight: 5,
        marginBottom: 3,
        borderRadius: '50%',
        backgroundColor: palette.success.main,
      },
    },

    absolute: {
      '&:before': {
        position: 'absolute',
        right: '100%',
        transform: 'translate(-1px, 1px)',
      },
    },

    noMarker: {
      '&:before': {
        display: 'none',
      },
    },
  };
};

// @ts-expect-error TS(2345): Argument of type '({ palette }: any) => { root: { ... Remove this comment to see the full error message
export default withStyles(styles)(GlobalIndicator);
